import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import styles from "@/styles/BlurImageBackground.module.scss";
import classnames from "classnames";
import Image from "next/legacy/image";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function BlurImageBackground(_ref) {
  let {
    item,
    children,
    className,
    imageOptions = {}
  } = _ref;
  const url = item.thumbnailUrl;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.container, {
      [styles.carousel]: className === "carousel",
      [styles.title]: className === "title"
    }),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.background,
      children: /*#__PURE__*/_jsx("figure", {
        children: !!url && /*#__PURE__*/_jsx(Image, _objectSpread({
          src: url,
          alt: item.name,
          layout: "fill",
          objectFit: "cover",
          objectPosition: "50% 50%"
        }, imageOptions))
      })
    }), children]
  });
}